import React from 'react';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Dialog,
    Grid,
    Typography
} from '@material-ui/core';
import AlertCards from '../profile/agentactivitydashboard/components/AlertCards';

function DashboardAlertsModal({ showModal, MODAL_TYPE }) {
    const handleClose = () => {
        showModal(MODAL_TYPE.NONE);
    };

    const handleDontShowAgainToday = () => {
        localStorage.setItem('dashboardAlertsLastShown', new Date().toISOString().split('T')[0]);
        showModal(MODAL_TYPE.NONE);
    };

    return (
        <Dialog
            aria-labelledby="dashboard-alerts-modal"
            maxWidth="md"
            fullWidth
            open
            onClose={handleClose}
        >
            <DialogTitle>
                <Typography variant="h6">Daily Recap</Typography>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <AlertCards onCardClick={handleClose} />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDontShowAgainToday} style={{ marginRight: 'auto' }}>
                    Don't show again today
                </Button>
                <Button variant="contained" color="primary" onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DashboardAlertsModal;
